import { createLazyComponent } from 'helpers/createLazyComponent'

const OrganizationSettingsLazy =
  createLazyComponent(() =>
    import('./OrganizationSettings')
  )

export default OrganizationSettingsLazy
